<template>
    <div class="duration-picker-component">
      <input type="number" v-model="durationCopy" :tabindex="tabindex" min="0" step="5" @blur="durationChanged" @focus="durationFocus" @keyup.enter="durationChanged" @keydown.esc="cancelChanges">
    </div>
  </template>
    
  <script>
import { ref, watch } from 'vue'
  
  export default {
    components: { },
    props: {
        modelValue: {
            type: [Number, null],
            required: false,
        },
        tabindex: {
            type: [Number, null],
            default: null,
        },
    },
    setup(props,{emit}) {
        const durationCopy = ref(null);
        let prevEmit = null;
        const resetDuration = () => {
            // console.log('resetDuration', props.modelValue);
            durationCopy.value = props.modelValue;
            prevEmit = durationCopy.value;
        }
        const emitNewValue = (value) => {
            if (value !== prevEmit) {
                // console.log('emitNewValue', value);
                emit('update:modelValue', value);
                prevEmit = value;
            } else {
                // console.log('don\'t emitNewValue', value);
            }
        };

        watch(() => props.modelValue, () => {
            resetDuration();
        });
        resetDuration();

        const durationChanged = () => {
            console.log('durationChanged', durationCopy.value);
            if (durationCopy.value === '') {
                durationCopy.value = null;
            }
            if (durationCopy.value !== null) {
                durationCopy.value = Math.max(0, Math.round(durationCopy.value / 5) * 5);
            }
            emitNewValue(durationCopy.value);
        }

        const cancelChanges = () => {
            durationCopy.value = prevEmit;
        }

        // selecte all text when focus
        const durationFocus = (event) => {
            event.target.select();
        }
        return {
            durationCopy,
            durationChanged,
            cancelChanges,
            durationFocus,
        };
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .duration-picker-component {
    input {
      width: 48px;
      background-color: white;
      border: 1px solid #767676;
    }
  }
  </style>